import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { PrefixUrlPipe } from '../../pipes/prefix-url.pipe';

@Component({
  selector: 'eventq-flag-alarm-toggle',
  imports: [PrefixUrlPipe],
  templateUrl: './flag-alarm-toggle.html',
  styleUrl: './flag-alarm-toggle.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqFlagAlarmToggle {
  readonly flagged = input(false);

  readonly flaggedChange = output<boolean>();

  toggle(): void {
    this.flaggedChange.emit(!this.flagged());
  }
}
